import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Avatar,
  CircularProgress
} from "@mui/material";
import api from "../../api/axios";

const CompanySettingsPage = () => {

  const [address, setAddress] = useState("");
  const [logo, setLogo] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadCompany();
  }, []);

  const loadCompany = async () => {
    try {
      const res = await api.get("/company/me");
      setAddress(res.data.address || "");
      if (res.data.logoPath) {
        setPreview(`http://35.168.97.96:8080/api/files/${res.data.logoPath}`);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    setLogo(file);
    setPreview(URL.createObjectURL(file));
  };

  const uploadLogo = async () => {
    if (!logo) return alert("Select logo first");

    const formData = new FormData();
    formData.append("file", logo);

    setLoading(true);
    try {
      await api.post("/company/logo", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      alert("Logo uploaded successfully");
    } catch (err) {
      console.error(err);
      alert("Upload failed");
    } finally {
      setLoading(false);
    }
  };

  const updateAddress = async () => {
    setLoading(true);
    try {
      await api.put("/company/address", { address });
      alert("Address updated");
    } catch (err) {
      console.error(err);
      alert("Update failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" fontWeight={700}>
        Company Settings
      </Typography>

      <Paper sx={{ p: 4, mt: 3 }}>

        {/* LOGO */}
        <Typography variant="h6">Company Logo</Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 3, mt: 2 }}>
          <Avatar
            src={preview}
            sx={{ width: 80, height: 80 }}
          />

          <Button variant="outlined" component="label">
            Select Logo
            <input type="file" hidden onChange={handleLogoChange} />
          </Button>

          <Button variant="contained" onClick={uploadLogo}>
            Upload
          </Button>
        </Box>

        {/* ADDRESS */}
        <Typography variant="h6" sx={{ mt: 4 }}>
          Company Address
        </Typography>

        <TextField
          fullWidth
          multiline
          rows={3}
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          sx={{ mt: 2 }}
        />

        <Button
          variant="contained"
          sx={{ mt: 2 }}
          onClick={updateAddress}
        >
          Save Address
        </Button>

        {loading && <CircularProgress sx={{ mt: 2 }} />}

      </Paper>
    </Box>
  );
};

export default CompanySettingsPage;